export default __webpack_public_path__ + "static/media/revenue_planning_module_preview.9a98a5b0.png";